export const settings = {
  _root: "/settings",
  general: "/general",
  inputs: "/inputs",
  farmNamePreferences: "/farm-name-preferences",
  logout: "/logout"
};
